define('all/slidingContentNavigation',['jquery', 'all/hash-monitor', 'all/player/session', 'all/hash-helper', 'all/pretty-links'], function ($, hashMonitor, session, hashHelper, prettyLinks) {
    'use strict';

    var hashToStartControllerClass = {};
	var hashBeforeSlidingContent = '';
    var oldHash = '';

    function setHash(hash, isClosingSlidingContent){

		if(hash === 'relogin'){
			// Start relogin without changing the hash so that we can continue to the real url afterwards
			var controllerStartClass = hashToStartControllerClass[hash.toUpperCase()];
			var controllerStartInstance = controllerStartClass.createInstance(undefined);
			showPanelFunction(controllerStartInstance);
			return;
		}


		var prettyBaseHash = prettyLinks.getHash(hash.split('$')[0]);
		if(prettyBaseHash !== '#!undefined'){
			hash = hash.replace(hash.split('$')[0], prettyBaseHash);
		} else{
			hash = '#!' + hash;
		}

        // Set the hash, and then the onHashChange() will create and start the controller
        var currentHash = top.location.hash.replace('#!', '');
        if(currentHash !== hash.replace('#!', '')){
            oldHash = currentHash;
            top.location.hash = hash;
        } else{
			console.log("double click on sliding content ...");
        }

		if(!isClosingSlidingContent){
			hashBeforeSlidingContent = currentHash;
		}


    }

	var showPanelFunction;

    function init(showPanel, createControllerObjectArray){
        $.each(createControllerObjectArray, function( index, value ) {
            hashToStartControllerClass[value.baseHashTag.toUpperCase()] = value;
        });

		showPanelFunction = showPanel;

        var defaultSlidingContentHashListener = function(e) {
            onHashChange(showPanel, e);
        };

        hashMonitor.addListener(defaultSlidingContentHashListener);
    }

    function setEmptyHash() {
        top.location.hash = '';
    }

    function replaceToOldOrSetEmptyHash(e){
        if(e !== undefined && e.originalEvent !== undefined){
            var oldUrl = e.originalEvent.oldURL;
            if(oldUrl !== undefined && oldUrl.length > 0 && oldUrl.indexOf('#!') > 0) {
                var oldHash = '#!' + oldUrl.substring(oldUrl.indexOf('#!') + 2);
                history.replaceState('', '', oldHash);
                return;
            }
        }
        // Someone manually wrote url in browser tab /se/casino/#!login, but we were already logged in
        // Then we should show were we are (e.g. welcome, casino or whatever) but not start showing the controller
        setEmptyHash();
    }



    function onHashChange(showPanel, event){

		if(isBackFromSlidingContentNavigation(event)){
			hashHelper.executeClosePanelFunction();
		}

        var hash = location.hash.substring(1);
        if(hash !== undefined && hash.length > 0){
            var hashSplit = hash.split('$');
            var prettyBaseHashTag = hashSplit[0].substring(1);
            var hashParameterMap = parseParams(hashSplit[1]);
			var prettyFlowKey = prettyLinks.getFlowkey(prettyBaseHashTag);
            var controllerStartClass = hashToStartControllerClass[prettyFlowKey.toUpperCase()];

            if(controllerStartClass !== undefined){
                if(controllerStartClass.dontShowIfAuthenticated === true && session.authenticated){
                    // the sliding content requires that player is not logged in, but player is logged in
                    // oldUrl = http://local-comeon.cleverdolphin.se:8080/se/casino/#!game=9966
                    // newUrl = http://local-comeon.cleverdolphin.se:8080/se/casino/#!login
                    replaceToOldOrSetEmptyHash(event);
                    return true;
                } else{
                    var controllerStartInstance = controllerStartClass.createInstance(hashParameterMap);
                    showPanel(controllerStartInstance);
                    return true;
                }
            }
            return false;
        }
        return false;
    }


    function isSlidingContentHash(){
        var hash = location.hash.substring(1);
        return isSlidingContentHashWithParameter(hash);
    }

    function isSlidingContentHashWithParameter(hash) {
		var baseHashTag = hash.split('$')[0].substring(1);
		var prettyFlowKey = prettyLinks.getFlowkey(baseHashTag);
        if (hash !== undefined && hash.length > 0 && hashToStartControllerClass[prettyFlowKey] !== undefined) {
            return true;
        } else {
            return false;
        }
    }

    function isGameOrGroupLoaded() {
        return (oldHash.indexOf('game') > -1 || oldHash.indexOf('group') > -1) && isSlidingContentHash();
    }

    function getHash(url) {
        if (typeof(url) === 'undefined') {
            return '';
        }
        return url.substring(url.indexOf('#!') + 1);
    }

    function isSlidingContentNavigation(originalEvent) {
		// hashBeforeSlidingContent is 'my-account'
		var hashAfterSlidingContent = getHash(originalEvent.newURL); // send-documents in case of new location or my-account if going to back to same location
		var hashInSlidingContent = getHash(originalEvent.oldURL); // withdraw
		var isBackFromSlidingContent = isSlidingContentHashWithParameter(hashInSlidingContent) && !isSlidingContentHashWithParameter(hashAfterSlidingContent);
		if(isBackFromSlidingContent && (hashBeforeSlidingContent !== '' && hashBeforeSlidingContent !== hashAfterSlidingContent.replace(/[#!]/g, ''))){
			return false;
		}
        return isSlidingContentHashWithParameter(hashInSlidingContent) || isSlidingContentHashWithParameter(hashAfterSlidingContent);
    }

	function isBackFromSlidingContentNavigation(event) {
		if(typeof(event) !== 'undefined') {
			var originalEvent = event.originalEvent;
			var newHash = getHash(originalEvent.newURL),
				oldHash = getHash(originalEvent.oldURL);
			return isSlidingContentHashWithParameter(oldHash) && !isSlidingContentHashWithParameter(newHash);
		}
		return false;
	}

    function decode(str, decodeRE) {
        return decodeURIComponent( str.replace(decodeRE, ' ') );
    }

    function parseParams(query) {
        var re = /([^&=]+)=?([^&]*)/g;
        var decodeRE = /\+/g;  // Regex for replacing addition symbol with a space
        var params = {}, e;
        while ( e = re.exec(query) ) {
            var k = decode( e[1], decodeRE), v = decode( e[2], decodeRE);
            if (k.substring(k.length - 2) === '[]') {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            }
            else {
                params[k] = v;
            }
        }
        return params;
    }

    function getOldOrEmptyHash(){
        var oldOrEmptyHash = oldHash;
        if(oldHash === undefined){
            oldOrEmptyHash = '';
        }
        return oldOrEmptyHash;
    }

    function goBackToPreviousHash() {
        setEmptyOrOldHash();
    }

    function setEmptyOrOldHash(){
        if(oldHash === ''){
            setEmptyHash();
        } else{
            setHash(oldHash, true);
        }
    }

    return {
        init: init,
        setHash: setHash,
        getOldOrEmptyHash: getOldOrEmptyHash,
        setEmptyOrOldHash: setEmptyOrOldHash,
        goBackToPreviousHash: goBackToPreviousHash,
        isGameOrGroupLoaded: isGameOrGroupLoaded,
        isSlidingContentNavigation: isSlidingContentNavigation,
		isSlidingContentHash: isSlidingContentHash
    };
});

